export default {
    _prefix: "LevelIndicator",
    subLevel: (data: { level: number; subLevel: number }) =>
        "{{level}}.{{subLevel}}",
};
